import { getLiveChatCTATemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";

const liveChatCTAConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Livechat CTA #1",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "ctaText",
          label: "Button text",
          placeholder: "Button text",
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "tel:+1234567890",
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
        {
          type: "checkbox",
          name: "pulsingAnimation",
          label: "Enable pulsing animation on button",
        },
        {
          type: "checkbox",
          name: "spaceBellow",
          label: "Add a space below the button",
        },
      ],
    },
    initialData: {
      bgColor: "#007bee",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getLiveChatCTATemplate({
        text: data.ctaText,
        url: data.url,
        bgColor: data.bgColor,
        pulsingAnimation: data.pulsingAnimation,
        spaceBellow: data.spaceBellow,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false);
      api.close();
    },
  });
};

export { liveChatCTAConfig };
